import React from "react";
import { ReactComponent as SupportIcon } from "../assets/group-107.svg";
import "../main.css";
import { Card, Grid, GridColumn } from "semantic-ui-react";

export default class UploadHelp extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <Grid.Row>
                    <Card className="w-100">
                        <Card.Content>
                            <Grid>
                                <GridColumn width={3} verticalAlign="middle">
                                    <SupportIcon />
                                </GridColumn>
                                <GridColumn width={13} textAlign="left">
                                    <p>
                                        If anything needs changing, we'll flag
                                        it up so you can fix before submitting.
                                        This will help prevent any delays to
                                        your programme getting off to a smooth
                                        start!
                                    </p>
                                    <p>
                                        If you need any help, give our schools
                                        experience team a call on
                                        <span
                                            className="bold"
                                            style={{ color: "#542eff" }}
                                        >
                                            {" "}
                                            0203 773 6025
                                        </span>{" "}
                                        or email
                                        <span
                                            className="bold"
                                            style={{ color: "#542eff" }}
                                        >
                                            {" "}
                                            schools@mytutor.co.uk
                                        </span>
                                    </p>
                                </GridColumn>
                            </Grid>
                        </Card.Content>
                    </Card>
                </Grid.Row>
            </>
        );
    }
}
